import React, { FC } from 'react';
import { isMobile } from 'react-device-detect';

const InfoMsg: FC = ({ children }) => (
    <div className={`fs-14 c-black-50 px-20 text-center ${isMobile ? 'py-30' : 'py-20'}`}>{children}</div>
);

export default InfoMsg;
